<template>
    <v-app>
        <div v-if="isLoading">
            <loaderVue />
        </div>
        <v-main v-if="isLoading == false">
            <headerBottomVue />
            <sliderVue v-if="$store.state.searchData.isSearchResult == false" />
            <v-card
                class="mx-auto"
                max-width="1300"
                v-if="$store.state.searchData.isSearchResult == true"
            >
                <searchvue />
            </v-card>

            <div v-if="$store.state.searchData.isSearchResult == false">
                <cardsVue />
                <newsVue />
                <institutesVue />
                <!--cookies-->
                <v-bottom-sheet persistent v-model="closeInfo">
                    <v-sheet class="pa-6 pb-15" height="my-auto">
                        <v-layout row wrap>
                            <v-flex xs12 class="text-left">
                                Ta strona korzysta z plików cookie, które
                                pomagają jej funkcjonować i śledzić sposób
                                interakcji z nią, dzięki czemu możemy zapewnić
                                lepszą i spersonalizowaną obsługę. Będziemy
                                używać plików cookie tylko wtedy, gdy wyrazisz
                                na to zgodę, klikając Akceptuj pliki cookies.
                                Jeśli klikniesz Odrzuć użyjemy tylko lików
                                cookie niezbędnych do działania naszej strony.
                                Możesz również zarządzać indywidualnymi
                                preferencjami dotyczącymi plików cookie klikając
                                w Preferencje. Używamy plików cookie, aby
                                oferować nasze funkcje oraz analizować ich
                                przydatność i wydajność, w celu poprawy
                                zadowolenia użytkowników.
                            </v-flex>

                            <v-flex md6 xs12>
                                <v-row
                                    class="pa-6 justify-center justify-md-end"
                                >
                                    <v-col> </v-col>
                                    <v-btn
                                        class="pa-6 mx-2"
                                        aria-label="Ustawienia zaawansowane"
                                        color="blue darken-5"
                                        outlined
                                        @click="settingsDialog = true"
                                    >
                                        Preferencje
                                    </v-btn>
                                    <!--
                                            <v-btn
                                                class="pa-6 mx-2"
                                                aria-label="Odrzuć "
                                                color="blue darken-5"
                                                outlined
                                                @click="
                                                    handleSetCookieSettings()
                                                "
                                            >
                                                Odrzuć
                                            </v-btn>
                                            -->
                                </v-row>
                            </v-flex>

                            <v-flex md6 xs12>
                                <v-row
                                    class="pa-6 justify-center justify-md-start"
                                >
                                    <v-btn
                                        class="pa-6"
                                        aria-label="Akceptuję i przechodzę do serwisu"
                                        dark
                                        color="blue darken-5"
                                        @click="handleGaIsAllow()"
                                    >
                                        Akceptuję i przechodzę do serwisu
                                    </v-btn>
                                </v-row>
                            </v-flex>
                        </v-layout>
                    </v-sheet>
                </v-bottom-sheet>
                <!--end cookies-->
            </div>
            <v-lazy
                v-model="isActive"
                :options="{
                    threshold: 0.5,
                }"
                min-height="300"
                transition="fade-transition"
            >
                <footerRedVue />
            </v-lazy>
            <footerBlueVue />
        </v-main>
        <!--dialog -->
        <v-row justify="center">
            <v-dialog
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
                v-model="settingsDialog"
            >
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-btn icon dark @click="settingsDialog = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title
                            >Ustawienia zaawansowane</v-toolbar-title
                        >
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card class="ma-2 pa-6 mx-auto" max-width="1280" tile>
                        <h2>Ustawienia prywatności</h2>
                        <div class="pa-6">
                            Ta strona używa ciasteczek oraz zewnętrznych
                            skryptów dla lepszego dostosowania treści do
                            użytkownika. Tutaj znajdziesz informacje o tym,
                            jakie ciasteczka i skrypty są używane oraz jaki
                            wpływ mają na twoją wizytę na stronie. W każdej
                            chwili możesz zmienić swoje ustawienia. Nie wpłynie
                            to na twoją wizytę na stronie.
                            <h3>
                                UWAGA: Te ustawienia mają zastosowanie jedynie w
                                przeglądarce i na urządzeniu, którego teraz
                                używasz
                            </h3>
                            <v-spacer></v-spacer>
                            <h2 class="pt-6 mt-3">
                                POLITYKA PRYWATNOŚCI I WYKORZYSTYWANIA PLIKÓW
                                COOKIES
                            </h2>
                            Informacja Jako Administrator Twoich danych
                            osobowych, które przetwarzamy poprzez naszą stronę
                            internetową zapewniamy, że dokładamy wszelkich
                            starań, by przetwarzanie to odbywało się z
                            poszanowaniem prywatności osób, których dane
                            dotycząoraz dbałością o bezpieczeństwo
                            przetwarzanych danych. Zapewniamy, że stosujemy
                            środki techniczne i organizacyjne zapewniające
                            ochronę przetwarzanych danych osobowych odpowiednią
                            do zagrożeń oraz kategorii danych objętych ochroną,
                            a w szczególności zabezpieczamy dane przed ich
                            udostępnieniem osobom nieupoważnionym, zabraniem
                            przez osobę nieuprawnioną, przetwarzaniem z
                            naruszeniem ustawy oraz zmianą, utratą, uszkodzeniem
                            lub zniszczeniem. <br />Akceptując niniejszą
                            Politykę prywatności wyrażasz zgodę na zasady
                            przetwarzania swoich danych osobowych w związku z
                            korzystaniem z naszej strony internetowej, opisane w
                            niniejszej Polityce prywatności.

                            <h3 class="pt-6 mt-3">
                                Definicje Ilekroć w Polityce Prywatności mowa o:
                            </h3>
                            <ol>
                                <li>
                                    Administratorze -rozumie się przez to
                                    Akademię Nauk Stosowanych Angelusa Silesiusa
                                    zsiedzibą w Wałbrzychu, ul. Zamkowa 4, kod
                                    pocztowy 58-300 Wałbrzych, adres e-mail:
                                    biurorektora@ans.edu.pl, tel. + 48 74 641 92
                                    00, zwany dalej ANS AS, reprezentowana przez
                                    prof. nadzw. dr. hab. Roberta Wiszniowskiego
                                    - Rektora.
                                </li>
                                <li>
                                    Danych Osobowych – rozumie się przez to
                                    informacje o zidentyfikowanej lub możliwej
                                    do zidentyfikowania osobie fizycznej.
                                    Możliwa do zidentyfikowania osoba fizyczna
                                    to osoba, którą można bezpośrednio lub
                                    pośrednio zidentyfikować;
                                </li>
                                <li>
                                    Oprogramowaniu – rozumie się przez to
                                    przeglądarki internetowe z których może
                                    korzystać Użytkownik, w celu korzystania ze
                                    strony internetowej;
                                </li>
                                <li>
                                    Przetwarzaniu Danych Osobowych – rozumie się
                                    przez to operację lub zestaw operacji
                                    wykonywanych na danych osobowych lub
                                    zestawach danych osobowych w sposób
                                    zautomatyzowany lub niezautomatyzowany, taką
                                    jak zbieranie, utrwalanie, organizowanie,
                                    porządkowanie, przechowywanie, adaptowanie
                                    lub modyfikowanie, pobieranie, przeglądanie,
                                    wykorzystywanie, ujawnianie poprzez
                                    przesłanie, rozpowszechnianie lub innego
                                    rodzaju udostępnianie, dopasowywanie lub
                                    łączenie, ograniczanie, usuwanie lub
                                    niszczenie;
                                </li>
                                <li>
                                    Strona internetowa – rozumie się przez to
                                    stronę internetową działającą pod adresem:
                                    www.ans.edu.pl;
                                </li>
                                <li>
                                    Urządzeniu – rozumie się przez to
                                    elektroniczne Urządzenie za pośrednictwem,
                                    którego Użytkownik uzyskuje dostęp do
                                    Serwisu.
                                </li>
                                <li>
                                    Użytkowniku – rozumie się przez to osobę,
                                    która korzysta ze strony;
                                </li>
                                <li>
                                    Plikach Cookies (tzw. ciasteczka) – rozumie
                                    się przez to małe pliki tekstowe, wysyłane
                                    przez stronę, zapisywane na urządzeniu
                                    Użytkownika, niezbędne do prawidłowego
                                    funkcjonowania strony, używane m.in. do
                                    identyfikacji i zliczania przeglądarek i
                                    urządzeń używanych do odwiedzania strony.
                                </li>
                            </ol>
                            <h2>Zasady przetwarzania Danych Osobowych</h2>
                            <ol>
                                <li>
                                    Dane osobowe Użytkowników będą przetwarzane
                                    przez Administratora w celu kontaktu z
                                    Użytkownikiem, a także dla celów
                                    statystycznych.
                                </li>
                                <li>
                                    Podstawą prawną przetwarzania danych będą
                                    art. 6 ust. 1 lit. a i lit. f RODO, tj.
                                    zgoda Użytkownika i prawnie uzasadniony
                                    interes Administratora- w odniesieniu do
                                    przetwarzania danych osobowych dla celów
                                    kontaktu między Użytkownikiem a
                                    Administratorem i celów statystycznych
                                    związanych z badaniem ruchu internetowego na
                                    stronie, dla oceny zainteresowania usługami
                                    oraz treściami zamieszczanymi na tronie oraz
                                    ulepszaniem jej zawartości.
                                </li>

                                <li>
                                    Podanie Danych Osobowych jest dobrowolne.
                                </li>
                                <li>
                                    Administrator przetwarza lub może
                                    przetwarzać następujące dane osobowe
                                    Użytkownika, które Użytkownik podaje
                                    dobrowolnie podczas wypełniania formularza:
                                    a. nazwisko i imię, b. adres e-mail, c.
                                    numer telefonu, d. inne dane zamieszczone
                                    dobrowolnie przez Użytkownika.
                                </li>
                                <li>
                                    Odbiorcami danych osobowych są osoby
                                    upoważnione przez Administratora do
                                    przetwarzania danych, współpracujące z
                                    Administratorem, w ramach wykonywania swoich
                                    obowiązków, podmioty którym Administrator
                                    zleca wykonanie czynności, z którymi wiąże
                                    się konieczność przetwarzania danych
                                    (podmioty przetwarzające), takie jak
                                    dostawcy usług teleinformatycznych,
                                    internetowych, księgowych i marketingowych,
                                    a także organy administracji publicznej lub
                                    organy wymiaru sprawiedliwości, jeśli
                                    Administrator będzie zobowiązany dane te
                                    przekazać na podstawie przepisów prawa.
                                </li>
                                <li>
                                    Administrator oświadcza, że w ramach
                                    przetwarzania danych osobowych w celach
                                    statystycznych może wykorzystywać narzędzia
                                    przeznaczone do analizy ruchu na stronie,
                                    takie jak Google Analytics oraz inne
                                    podobne.
                                </li>
                                <li>
                                    Administrator uwzględniając stan wiedzy
                                    technicznej, koszt wdrażania oraz charakter,
                                    zakres, kontekst i cele przetwarzania oraz
                                    ryzyko naruszenia praw lub wolności osób
                                    fizycznych o różnym prawdopodobieństwie
                                    wystąpienia i wadze zagrożenia, wdraża
                                    odpowiednie środki techniczne i
                                    organizacyjne, aby zapewnić stopień
                                    bezpieczeństwa odpowiadający temu ryzyku.
                                </li>
                                <li>
                                    Administrator zapewnia także regularne
                                    ocenianie skuteczności środków technicznych
                                    i organizacyjnych mających zapewnić
                                    bezpieczeństwo przetwarzania danych
                                    osobowych.
                                </li>
                            </ol>
                            <h2>Prawa użytkowników</h2>
                            <li>1. Użytkownikowi przysługuje:</li>
                            <ul>
                                <li>
                                    a) prawo dostępu do treści swoich danych
                                    osobowych, czyli prawo do uzyskania
                                    potwierdzenia czy Administrator przetwarza
                                    dane oraz informacji dotyczących takiego
                                    przetwarzania,
                                </li>

                                <li>
                                    b) prawo do sprostowania danych, jeżeli dane
                                    przetwarzane przez Administratora są
                                    nieprawidłowe lub niekompletne,
                                </li>

                                <li>
                                    c) prawo żądania od Administratora usunięcia
                                    danych,
                                </li>

                                <li>
                                    d) prawo żądania od Administratora
                                    ograniczenia przetwarzania danych,
                                </li>

                                <li>
                                    e) prawo wniesienia sprzeciwu wobec
                                    przetwarzania danych na podstawie
                                    uzasadnionego interesu Administratora,
                                </li>

                                <li>
                                    f) prawo do przeniesienia danych do innego
                                    administratora danych, 2. Prawa wymienione w
                                    powyższych punktach można zrealizować
                                    bezpośrednio poprzez kontakt z Inspektorem
                                    Ochrony Danych Osobowych (IOD@ans.edu.pl )
                                    lub przez kontakt z ANS AS (
                                    biurorektora@ans.edu.pl ) h) prawo
                                    wniesienia skargi do organu nadzorczego, tj.
                                    Prezesa Urzędu Ochrony Danych Osobowych,
                                    jeśli przetwarzanie danych osobowych jej
                                    dotyczących przez Administratora narusza
                                    przepisy unijnego rozporządzenia RODO. 3.
                                    Realizacja uprawnień, o których mowa w pkt
                                    h) może odbywać się poprzez uprzednie
                                    pisemne wskazanie swoich żądań przesłane na
                                    adres Administratora.
                                </li>
                            </ul>
                            <h3>Pliki cookies</h3>
                            Administrator za pośrednictwem strony wykorzystuje
                            Pliki Cookies. Na stronie stosowane są dwa
                            zasadnicze rodzaje Plików Cookies:
                            <ol>
                                <li>
                                    sesyjne – są to pliki tymczasowe, które
                                    przechowywane są w urządzeniu Użytkownika do
                                    czasu wylogowania, opuszczenia strony lub
                                    wyłączenia oprogramowania;
                                </li>
                                <li>
                                    stałe – są to pliki przechowywane w
                                    urządzeniu Użytkownika przez określony w
                                    parametrach Plików Cookies lub do czasu ich
                                    usunięcia przez Użytkownika.
                                </li>
                            </ol>

                            <h2>
                                Na stronie mogą być stosowane wszystkie lub
                                niektóre z następujących rodzajów Plików
                                Cookies:
                            </h2>
                            <ol>
                                <li>
                                    „niezbędne”, które umożliwiają korzystanie z
                                    usług dostępnych w ramach strony,
                                </li>
                                <li>
                                    „wydajnościowe”, które umożliwiają zbieranie
                                    informacji o sposobie korzystania ze strony
                                    internetowej;
                                </li>
                                <li>
                                    „funkcjonalne”, które umożliwiają zachowanie
                                    wybranych przez Użytkownika ustawień i
                                    personalizację interfejsu Użytkownika, np.
                                    poprzez język, rozmiar czcionki, wyglądu
                                    strony internetowej.
                                </li>
                                <li>Pliki Cookies wykorzystywane są w celu:</li>
                            </ol>
                            <ol>
                                <li>
                                    dostosowania zawartości strony do
                                    preferencji Użytkownika oraz optymalizacji
                                    jej korzystania; w szczególności umożliwia
                                    to rozpoznanie i wyświetlenie strony na
                                    urządzeniu Użytkownika, dostosowaną do jego
                                    indywidualnych preferencji;
                                </li>
                                <li>
                                    tworzenie statystyk, które wspierają
                                    obserwację korzystania ze strony przez
                                    Użytkowników, co wpływa na ulepszenie jej
                                    struktury i treści. 5. Stosowane na stronie
                                    rozwiązania są bezpieczne dla urządzeń
                                    Użytkowników. Postanowienia końcowe 1. Na
                                    stronie mogą pojawiać się linki do innych
                                    stron internetowych. Takie strony
                                    internetowe działają niezależnie od
                                    Administratora i nie są w żaden sposób przez
                                    niego nadzorowane. Strony te mogą posiadać
                                    własne polityki dotyczące prywatności oraz
                                    regulaminy, z którymi Użytkownik powinien
                                    się zapoznać.
                                </li>
                                <li>
                                    Administrator zastrzega sobie prawo zmiany
                                    niniejszej Polityki Prywatności.
                                </li>
                                <li>
                                    O wszelkich zmianach Polityki Prywatności
                                    Użytkownicy będą informowani na stronie
                                    poprzez okienko informacyjne.
                                </li>
                                <li>
                                    Pytania, uwagi i prośby związane z niniejszą
                                    Polityką prywatności prosimy wysyłać drogą
                                    e-mailową na adres e-mail: IOD@ans.edu.pl
                                </li>
                            </ol>
                        </div>

                        <!--Usługi analityczne-->
                        <div class="pa-3">
                            <h3>Usługi analityczne</h3>
                            W celu świadczenia przez Administratora usług oraz
                            ich ulepszania i analizy, posługuje się on usługami
                            i narzędziami innych podmiotów, m.in.: Google
                            Analytics. W Serwisie używane są narzędzia Google
                            Analitycs dostarczane przez Google Inc. z siedzibą w
                            USA (dalej: Google) – usługa analityczna, wykonywana
                            przy wykorzystaniu plików cookies. Informacje
                            wytworzone przez pliki cookie na temat korzystania
                            przez Użytkownika z Serwisu dostępne są pod adresem
                            https://policies.google.com/privacy?hl=pl, są
                            przekazywane i zapisywane na serwerze Google w USA.
                            Serwis stosuje anonimizację adresów IP, która
                            powoduje wcześniejsze skrócenie adresów IP
                            użytkowników Google w państwach członkowskich Unii
                            Europejskiej lub w innych państwach będących
                            stronami Porozumienia o Europejskim Obszarze
                            Gospodarczym. Google wykorzystuje pozyskane
                            informacje w celu weryfikacji korzystania przez
                            Użytkownika z usług Administratora, tworzenia
                            raportów o ich funkcjonalności, a także w celu
                            świadczenia dodatkowych usług na rzecz
                            Administratora związanych z korzystaniem z usług
                            cyfrowych lub Internetu, w szczególności raportów
                            Google Analytics dotyczących świadczonych usług
                            według kryteriów demograficznych i zainteresowań.
                            Dane przekazywane do Google posłużyć mogą nadto do:
                            uzyskania raportów wyświetleń w sieci reklamowej
                            Google; uzyskania raportów danych demograficznych i
                            zainteresowań w Google Analytics; zintegrowania
                            usługi, które wymagają od Google Analytics zbierania
                            danych do celów reklamowych, w tym z wykorzystaniem
                            identyfikatorów i plików cookie dotyczących reklam.
                            <v-switch v-model="isAllowGA"></v-switch>
                        </div>
                        <!--Usługi analityczne-->
                        <v-divider></v-divider>

                        <!--cookie setting-->
                        <div>
                            <v-btn
                                class="pa-6 ma-3"
                                aria-label="Zapisz"
                                color="blue darken-5"
                                outlined
                                @click="handleSetCookieSettings()"
                            >
                                Zapisz
                            </v-btn>
                            <v-btn
                                class="pa-6 ma-3"
                                aria-label="Włącz wszystkie i przejdź do serwisu"
                                dark
                                color="blue darken-5"
                                @click="handleGaIsAllow()"
                            >
                                Włącz wszystkie i przejdź do serwisu
                            </v-btn>
                        </div>
                        <!--cookie setting-->
                    </v-card>
                </v-card>
            </v-dialog>
        </v-row>
    </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import loaderVue from "./Loader.vue";
import headerBottomVue from "./HeaderBottom.vue";
import searchvue from "./Search.vue";
import cardsVue from "./Cards.vue";
import sliderVue from "./Slider.vue";
import newsVue from "./pages/news.vue";
import newsDetailsvue from "./pages/newsDetails.vue";
import institutesVue from "./Institutes.vue";
import footerBlueVue from "./FooterBlue.vue";
import footerRedVue from "./FooterRed.vue";

import { bootstrap } from "vue-gtag";

export default {
    components: {
        sliderVue,
        headerBottomVue,
        searchvue,
        cardsVue,
        institutesVue,
        footerRedVue,
        footerBlueVue,
        newsDetailsvue,
        newsVue,
        loaderVue,
    },

    data() {
        return {
            closeInfo: false,
            cookies: [],
            isAllowGA: false,
            cookieSettings: false,
            settingsDialog: false,
            isActive: false,
            isLoading: false,
            searchData: [],
            isSearchResult: false,
        };
    },

    methods: {
        track_RODO() {
            this.$gtag.event("RODO", {
                event_category: "Cookies",
                event_label: "Zgoda na analytics",
            });
        },

        async handleGaIsAllow() {
            this.isAllowGA = true;
            const res = await this.callApi("post", "/set_cookie", {
                puasGA: this.isAllowGA,
            });

            if (res.status == 200) {
                this.closeInfo = false;
                this.settingsDialog = false;
                bootstrap().then((gtag) => {
                    this.track_RODO();
                });

                // res.data;
            }
        },

        async handleSetCookieSettings() {
            //console.log("stan this.isAllowGA", this.isAllowGA);
            const res = await this.callApi("post", "/set_cookie", {
                puasGA: this.isAllowGA,
            });
            if (this.isAllowGA == true) {
                bootstrap().then((gtag) => {
                    //console.log("gtag all done!");
                });
            } else {
                //console.log("brak zgody na Analytics");
            }
            this.closeInfo = false;
            this.settingsDialog = false;
        },

        async handleCookieSettingsAllow1() {
            const [res] = await Promise.all([
                this.callApi("get", "get_cookie"),
            ]);
            if (res.status == 200) {
                this.cookies = res.data;
                window["ga-disable-G-DHXKP3C7H9"] = false;
            }
        },
    },

    async created() {
        //      this.isLoading=true;
        const [res] = await Promise.all([this.callApi("get", "get_cookie")]);
        if (res.status == 200) {
            if (res.data == 1) {
                this.closeInfo = false;
                this.settingsDialog = false;
            } else {
                this.closeInfo = true;
            }
        }
        //                        this.isLoading = false;
    },
};
</script>

<style>
ol {
    margin-left: 25px;
}
#post >>> iframe {
    border: 15px solid #f5f5f5;
    width: 100%;
    min-height: 640px;
    min-height: 720px;
}
#post {
    overflow-wrap: break-word;
}
#post >>> p {
    line-height: 1.8em;
    padding: 5px;
}
#post >>> h1 {
    background: #f5f5f5;
    text-transform: uppercase;
    border-left: 6px solid #db0f38;
    border-top: 1px solid #e9e9e9;
    border-right: 1px solid #e9e9e9;
    border-bottom: 1px solid #e9e9e9;
    font-weight: normal;
    padding: 8px;
    color: black;
    margin: 0px 0px 0px 0px;
}

#post >>> hr {
    margin: 5px 0px 30px 0px;
    color: #e9e9e9;
    border: 1px solid #e9e9e9;
}

#post >>> h2 {
    background: #f5f5f5;
    border-left: 6px solid #4476b8;
    border-top: 1px solid #e9e9e9;
    border-right: 1px solid #e9e9e9;
    border-bottom: 1px solid #e9e9e9;
    font-weight: normal;
    padding: 10px 0px 10px 10px;
    margin: 0px 0px 10px 0px;
}

#post >>> h3 {
    border-left: 6px solid #05355a;
    background: #f5f5f5;
    border-top: 1px solid #e9e9e9;
    border-right: 1px solid #e9e9e9;
    border-bottom: 1px solid #e9e9e9;
    font-weight: 600;
    padding: 10px 0px 10px 10px;
    margin: 0px 0px 10px 0px;
}

.attach {
    background: #05355a;
}

#post >>> ul,
ol {
    padding: 5px;
    margin-bottom: 20px;
}
#post >>> li {
    margin-left: 2.5em;
    padding: 2px;
}

#post >>> li:first-child {
    margin-left: 2.5em;
    padding: 2px;
    border: 0px solid red;
    margin-top: -20px;
}
#post >>> tr td {
    padding: 10px;
}

#breadcrumbs {
    margin: 0px 15px 0px 0px;
    padding: 10px;
    background: #f5f5f5;
}

#headerMenu {
    color: white;
    font-weight: bold;
    overflow-wrap: break-word;
    min-height: 50px;
    text-transform: uppercase;
}

#headerMenu >>> .col1 {
    background: #05355a;
}
#headerMenu >>> .col2 {
    background: #05355a;
    padding: 5px;
}
</style>
